import { useMemo } from "react";
import type { UIMessage } from "@ai-sdk/react";

export interface CompletionMeta {
  inputTokens: number;
  outputTokens: number;
  durationMs: number;
  model: string;
  toolCalls: number;
}

export function useChatCompletion(
  messages: UIMessage[] | undefined,
  chatStatus: string,
): CompletionMeta | null {
  return useMemo(() => {
    if (!messages || messages.length === 0) return null;
    if (chatStatus !== "ready") return null;

    for (let i = messages.length - 1; i >= 0; i--) {
      const msg = messages[i]!;
      if (msg.role !== "assistant" || !msg.parts) continue;

      for (let j = msg.parts.length - 1; j >= 0; j--) {
        const part = msg.parts[j] as unknown as Record<string, unknown>;
        if (part?.type !== "data") continue;

        const data = part.data;
        if (!Array.isArray(data)) continue;

        for (const item of data) {
          if (
            typeof item === "object" &&
            item !== null &&
            (item as Record<string, unknown>).type === "completion"
          ) {
            const c = item as Record<string, unknown>;
            return {
              inputTokens: (c.inputTokens as number) ?? 0,
              outputTokens: (c.outputTokens as number) ?? 0,
              durationMs: (c.durationMs as number) ?? 0,
              model: (c.model as string) ?? "",
              toolCalls: (c.toolCalls as number) ?? 0,
            };
          }
        }
      }
    }

    return null;
  }, [messages, chatStatus]);
}
